import { OptionsItemLiveData, OptionsItemThemeData, OptionsItemThemeItemData } from "../../types/types";
import { GetMultiAtlasScalingVariantDataByScale } from "../../utils/Utils";
import { LoaderFileKeys } from "../constant/AppConstants";
import { LiveDataChangeEvents, OptionsDataManager } from "./OptionsDataManager";
import { AppLocalStorage } from "./AppLocalStorage";
import { OptionsItemKeys } from "./LayoutDataManager";
import { ThemeDataManager } from "./ThemeDataManager";

/**
 * For simplicity and UX, all card decks are loaded in advance.
 * Each background will get it's own key, and background can be swapped by said key.
 * NOTE: this increases initial loading times.
 */
export class CardDecksManager
{
    private static scene: Phaser.Scene;
    private static cardsDeckTexture: Phaser.Textures.DynamicTexture;


    public static Init(scene:Phaser.Scene): void
    {
        this.scene = scene;
        OptionsDataManager.GetEventEmitter().on(LiveDataChangeEvents.CARD_DECK_CHANGE, this.OnCardDeckDataChange, this);
    }

    /**
     * NOTE: cardsDeck atlases cant be compressed textures, because we use STAMP from cardsDeck texture to DynamicTexture. Thus we'll use PNG atlases.
     * 
     * @param scene We use this scene's preload()'s load queue to load all backgrounds
     */
    public static Preload(scalingVariantsScale: number): void
    {
        // for each background
        const path: string = "./atlas";
        const itemThemeData: OptionsItemThemeData = ThemeDataManager.GetSharedData().options.itemsById[OptionsItemKeys.cardDeck];
        itemThemeData.items.forEach((item:OptionsItemThemeItemData, i:number)=>{
            const cardsDeckAtlasData = GetMultiAtlasScalingVariantDataByScale(
                item.source.variants,
                scalingVariantsScale,
            );
            this.scene.load.multiatlas(LoaderFileKeys.cardsDeck + i, cardsDeckAtlasData.atlasURL, cardsDeckAtlasData.path);
        });
    }

    /**
     * Build DynamicTexture in TextureManager and pull Frames from correct/current CardsDeck
     * ^ this texture is used by Cards in CardsManager (via its 'key').
     */
    public static Build(): void
    {
        const bg0Texture: Phaser.Textures.Texture = this.scene.textures.get(LoaderFileKeys.cardsDeck + 0);
        // if got a card deck texture
        if (bg0Texture.key != "__MISSING") {
            // create dynamic texture of same size
            const size: any = bg0Texture.customData["size"];
            this.cardsDeckTexture = this.scene.textures.addDynamicTexture(LoaderFileKeys.cardsDeck, size.w, size.h);
        }
        
        const curCardsDeckIndex: number = OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.cardDeck).value as number;
        this.SetCardsDeckIndex(curCardsDeckIndex);
    }
    
    private static OnCardDeckDataChange(cardDeckIndex: number): void
    {
        // change views
        this.SetCardsDeckIndex(cardDeckIndex);
    }

    /**
     * Set correct cards deck index for views (dynamic texture = views autoupdate)
     * NOTE: private, since this class will auto-react via event listener to CARD_DECK (index) change
     * 
     * @param cardsDeckIndex 
     */
    private static SetCardsDeckIndex(cardsDeckIndex: number): void
    {
        // console.log("SetCardsDeckIndex", cardsDeckIndex);

        const sourceTextureKey: string = LoaderFileKeys.cardsDeck + cardsDeckIndex;
        const cardsDeckFrames: Record<string, Phaser.Textures.Frame> = this.scene.textures.get(LoaderFileKeys.cardsDeck+cardsDeckIndex).frames as Record<string, Phaser.Textures.Frame>;
        for (var frameKey in cardsDeckFrames) {
            const frame: Phaser.Textures.Frame = cardsDeckFrames[frameKey];
            const pivotX: number = frame.customPivot ? frame.pivotX : frame.centerX;
            const pivotY: number = frame.customPivot ? frame.pivotY : frame.centerY;
            // stamp frame pixels
            this.cardsDeckTexture.stamp(sourceTextureKey, frameKey, frame.cutX + pivotX, frame.cutY + pivotY);
            // add frame data
            // console.log(frameKey, frame.sourceIndex, frame.cutX + pivotX+4, frame.cutY + pivotY+4, frame.width, frame.height);
            // console.log(frame.cutX, frame.cutY);
            // console.log(frameKey, frame.sourceIndex, frame.cutX, frame.cutY, frame.width, frame.height);
            this.cardsDeckTexture.add(frameKey, frame.sourceIndex, frame.cutX, frame.cutY, frame.width, frame.height);
        }
        // console.log(this.cardsDeckTexture.source[0].compressionAlgorithm)
    }
}